(() => {
  const modelDataSelector = '[id^="ProductJSON-"]';

  if (document.querySelector(modelDataSelector) || !window.ProductModel) return;

  const loadShopifyXR = window.ProductModel.loadShopifyXR;
  if (typeof loadShopifyXR !== 'function') return;

  window.ProductModel.loadShopifyXR = function guardedLoadShopifyXR() {
    if (!document.querySelector(modelDataSelector)) return;

    window.ProductModel.loadShopifyXR = loadShopifyXR;
    return loadShopifyXR.call(window.ProductModel);
  };
})();
